"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeaderWrapper = exports.StyledSubTitle = exports.StyledTitle = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.StyledTitle = theme_1.styled.h2 `
  ${theme_1.typography.medium20};
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};

  ${theme_1.media.desktop} {
    ${theme_1.typography.medium24};
  }

  ${({ marginBottom }) => marginBottom &&
    (0, theme_1.css) `
      margin-bottom: ${marginBottom}px;
    `}
`;
exports.StyledSubTitle = theme_1.styled.h3 `
  ${theme_1.typography.regular16}
  line-height: 24px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`;
exports.StyledHeaderWrapper = theme_1.styled.div ``;
